import React from "react";
import * as Flows from "flows/constants";
import FlowContainer from "flows";

// TODO: Move this into web/src/flows/index?
export const AddCard = () => <FlowContainer flow={Flows.ADDCARD} />;
export const AddPM = () => <FlowContainer flow={Flows.ADDPM} />;
export const Deposit = () => <FlowContainer flow={Flows.DEPOSIT} />;
export const PayoutV2 = () => <FlowContainer flow={Flows.PAYOUTV2} />;
export const PayoutFull = () => <FlowContainer flow={Flows.PAYOUT_FULL} />;
export const GDPR = () => <FlowContainer flow={Flows.GDPR} />;
export const KYC = () => <FlowContainer flow={Flows.KYC} />;
export const KYC2 = () => <FlowContainer flow={Flows.KYC2} />;
export const PM = () => <FlowContainer flow={Flows.PM} />;
export const Payout = () => <FlowContainer flow={Flows.PAYOUT} />;
export const Purchase = () => <FlowContainer flow={Flows.PURCHASE} />;
export const Checkout = () => <FlowContainer flow={Flows.CHECKOUT} />;
export const TxnHistoryFlow = () => <FlowContainer flow={Flows.TXNHISTORY} />;
export const TxnDetails = () => <FlowContainer flow={Flows.TXNDETAILS} />;
export const TOS = () => <FlowContainer flow={Flows.TOS} />;
export const PaymentSelectionFlow = () => <FlowContainer flow={Flows.PAYMENT_SELECTION} />;
export const PaymentMethodManagementFlow = () => <FlowContainer flow={Flows.PAYMENT_METHOD_MANAGEMENT} />;
export const SessionID = () => <FlowContainer flow={Flows.SESSION_ID} />;

export { Error } from "./Error";
export { NotFound } from "./NotFound";
export { PaypalCallback } from "./PaypalCallback";
export { PlaidACH } from "./PlaidACH";
export { ThreeDS2Callback } from "./3DS2Callback";
